import React from "react";
import { useGetProjectTreeQuery } from "src/api/v1/get-project-tree-ApiSlice";
import { useGetAuthKeyQuery } from "src/api/auth-token-ApiSlice";
import { GetProjectTreeProject } from "src/model/api/get-project-tree-project.model";
import { Navigate } from "react-router";
import AppHeader from "src/components/AppHeader/AppHeader";

interface HomePageState {
  projectTree: GetProjectTreeProject[];
}

function useHomePageState(): HomePageState {
  const token = useGetAuthKeyQuery()
  const {data: projectTree} = useGetProjectTreeQuery(undefined, {
    skip: !(token.data?.token)
  })
  return {
    projectTree,
  } as HomePageState
}

function isStateReady(state: HomePageState): boolean {
  return state.projectTree != null;
}


export default function HomePage() {

  const state = useHomePageState();

  if (isStateReady(state)) {
    if (state.projectTree?.length === 0) {
      return <Navigate to="/welcome"/>
    } else {
      return <Navigate to="/projects"/>
    }
  } else {
    return <AppHeader />
  }

}
